module.exports = __webpack_public_path__ + "img/rec-11.54b808d9.png";